import React from "react"
import PropTypes from "prop-types"
import tw, { styled } from "twin.macro"
import noise from "@images/noise.png"

const Section = styled.section`
  ${tw`relative z-10 overflow-hidden bg-white py-c68 2xl:pb-c96 2xl:pb-c145`}
`
const Wrapper = styled.div`
  ${tw`relative z-10 px-offset md:px-offsetMd xl:px-24`}
`

const WpAcfSimpleCardsModuleBlock = ({ moduleData }) => {
  const { headline, cards } = moduleData.acfSimpleCards || {}

  return (
    <Section>
      <iframe
        src="https://cdn.lottielab.com/l/2prE7D7DZUBdmP.html"
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "100%",
          height: "100%",
          transform: "translateX(50%)",
          zIndex: -1,
        }}
      />
      <img
        className="absolute z-[-1] top-0 left-0 w-full h-full mix-blend-overlay"
        src={noise}
        alt=""
      />
      <Wrapper>
        <h2 className="font-bold text-left text-black text-42 md:text-40 lg:text-48 2xl:text-60 font-ubuntu mb-c120 2xl:mb-c200">
          {headline}
        </h2>
        <div className="grid w-full grid-cols-1 md:grid-cols-2 cards-wrapper xl:grid-cols-3 gap-x-c40 3xl:gap-x-c80 gap-y-c80 md:gap-y-c145">
          {cards?.map((card, index) => (
            <div
              key={index}
              className="group card p-c30 bg-white xl:p-c40 rounded-[30px] transition-all duration-300 relative self-baseline"
            >
              <span className="block font-bold text-blue transition-colors duration-300 text-80 xl:text-100 font-ubuntu   absolute left-0 -top-c62 xl:-top-c78">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className="font-bold text-black transition-colors duration-300 text-40 font-ubuntu mb-c20 md:mb-c30 ">
                {card.title}
              </h3>
              <p className="text-black transition-colors duration-300 text-16 font-firacode ">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </Wrapper>
    </Section>
  )
}

WpAcfSimpleCardsModuleBlock.propTypes = {
  moduleData: PropTypes.object,
}

WpAcfSimpleCardsModuleBlock.defaultProps = {
  moduleData: {},
}

export default WpAcfSimpleCardsModuleBlock
